// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".vx-activities__card{margin-right:4rem;margin-bottom:4rem;max-width:30rem}.vx-filter-bar{margin:8rem}.vx-filter-item{width:28rem;height:3.6rem}\n", ""]);
// Exports
module.exports = exports;
